import React from 'react';
import CSSModules from 'react-css-modules';
import style from './icon.scss';

const Icon = props => (
  <i className={`Icon icon-${props.name}`} styleName="root" />
);

export default CSSModules(Icon, style);



// WEBPACK FOOTER //
// ./src/components/common/icon.js